var $ = require("./lib/qsa");
var debounce = require("./lib/debounce");

var scrollListener = debounce(function(e) {
  targets = targets.filter(function(t) {
    var bounds = t.getBoundingClientRect();
    if (bounds.top > -window.innerHeight / 2 && bounds.top < window.innerHeight * .75) {
      t.classList.add("activated");
      return false;
    }
    return true;
  });
  if (!targets.length) window.removeEventListener("scroll", scrollListener);
});

var targets = $("[scroll-activated]");

setTimeout(scrollListener, 1000);

window.addEventListener("scroll", scrollListener);
